// =============== UNIFIED QUESTION LAKE ===============
// Central question repository for frontend assessment engine

import { PERSONALITY_QUESTIONS } from '../modules/extendedAssessment/questions/personality';
import { COGNITIVE_QUESTIONS } from '../modules/extendedAssessment/questions/cognitive';
import { EMOTIONAL_QUESTIONS } from '../modules/extendedAssessment/questions/emotional';
import { SITUATIONAL_QUESTIONS } from '../modules/extendedAssessment/questions/situational';
import { MOTIVATION_QUESTIONS } from '../modules/extendedAssessment/questions/motivation';
import { BEHAVIORAL_QUESTIONS } from '../modules/extendedAssessment/questions/behavioral';
import { MINDFULNESS_QUESTIONS } from '../modules/extendedAssessment/questions/mindfulness';

export const QUESTION_LAKE = {
  personality: PERSONALITY_QUESTIONS,
  cognitive: COGNITIVE_QUESTIONS,
  emotional: EMOTIONAL_QUESTIONS,
  situational: SITUATIONAL_QUESTIONS,
  motivation: MOTIVATION_QUESTIONS,
  behavioral: BEHAVIORAL_QUESTIONS,
  mindfulness: MINDFULNESS_QUESTIONS
};

export const getQuestionsByModule = (module) => QUESTION_LAKE[module] || [];
